import type { ComponentProps } from "react";

// assistant-ui Badge dimensions and variants, using WorkView's color tokens.
// Design source: https://r.assistant-ui.com/base/badge.json
const variants = {
  default: "bg-[var(--ink)] text-[var(--paper)]",
  secondary: "bg-[var(--wash)] text-[var(--ink)]",
  destructive: "bg-[var(--st-alert)] text-white",
  outline: "border-[var(--line)] text-[var(--ink)]",
  ghost: "text-[var(--ink)]",
  link: "text-[var(--accent)] underline-offset-4",
};

export function Badge({ variant = "default", className = "", ...props }: ComponentProps<"span"> & { variant?: keyof typeof variants }) {
  return <span {...props} data-slot="badge" data-variant={variant} className={[
    "inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-full border border-transparent px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-colors [&>svg]:pointer-events-none [&>svg]:size-3",
    variants[variant], className,
  ].join(" ")} />;
}
